/* Ladder colours and tape widths per product - 11 August 2026.

   WHY THIS EXISTS. The configurator offered ONE list of six colours, LN 01 to
   LN 42, at every slat width, and only ever when the textile tape was chosen.
   That is the 12 mm tape range from the 25 mm blind. It is wrong everywhere
   else, and it also means that on a blind with a CORD ladder we never asked for
   a colour at all - a field the factory's own ordering portal does ask for.

   WHERE THE COLOURS COME FROM. The client sent screen captures of the Anwis
   ordering portal. The codes are read off those captures; the shades were
   sampled programmatically from the centre of each swatch. Good enough to pick
   from on screen, but NOT colour-card values - a screenshot has been through
   JPEG and a monitor profile. The price list is no help: searching all 443
   pages finds none of these codes, because it defers to the separate sample
   catalogue for every colour of a wooden part.

   THE NUMBER IS THE COLOUR, THE PREFIX IS THE LADDER. Every one of the six LN
   codes we already had exists again in LT, and the nine LW codes are an exact
   subset of LT, with matching shades - LN 27, LT 27 and LS 27 are all the same
   black. So LN is the 12 mm tape, LT the 50 mm tape, LW the 38 mm tape, and LS
   the cord ladder. That is why the six names below can be reused across ranges.

   NAMES. Only six colours have names, and they are DESCRIPTIVE ones read off
   the photographs - not Anwis's official names, which we do not have. The other
   codes show the code alone rather than a name invented to fill the gap. The
   code is what the factory reads on the order in any case.

   PHOTOGRAPHS, when they arrive. Every entry here carries its own icon id, and
   the configurator's ill() prefers NWC_UI.PHOTO[id] over the drawn fallback. So
   uploading a photograph under the matching key replaces the drawing with no
   code change at all. The keys are lad_LT01 ... lad_LT91, lad_LW01 ... lad_LW44,
   lad_LS01 ... lad_LS44 for the colours, and tape_10 / tape_12 / tape_25 /
   tape_38 for the four tape widths.

   NOT COVERED YET, and deliberately left on the old six-colour LN list rather
   than guessed at: bamboo 50 mm, and both 25 mm products. No captures for those.

   THE TAPE WIDTHS, and this part IS from the price list - the ADDITIONAL
   OPTIONS table under every product, read per OPERATION, because the operation
   is what changes the list. The pages that matter to us are C+T, mono chain and
   motorised; Twin Pull and Retro are systems we do not sell and are ignored.

     25 mm wood (DKZ/DOZ), 25 mm bamboo (DFZ)   12 mm                     +7%
     50 mm wood (DLZ/DMZ/DRZ)  C+T              25 free, 10 and 38        +5%
                               mono chain       25 free, 10               +5%
                               motorised        25 free, 38               +5%
     50 mm bamboo (DDZ)        C+T              25 free, 10 and 38        +5%
                               mono chain       25 free
                               motorised        25 free, 38               +5%
     70 mm wood (DNZ)          C+T, motorised   38 only                   +5%
     65 mm bamboo (DGZ)        C+T              38 only                   +5%
                               motorised        no tape ladder at all

   Two things that were wrong before this table existed. The configurator
   charged one percentage for one tape labelled "12 mm" everywhere, so at 50 mm
   it took 7% for a tape the manufacturer gives away and at 70 and 65 mm it took
   7% where the list says 5%. And it forced the cord ladder whenever the chain
   was picked - but the mono chain page offers the 25 mm tape free and the 10 mm
   tape at +5%. Note 13 on that page says the STANDARD blind is fitted with a
   cord ladder, which is a default, not a prohibition.

   The 25 mm blinds get the same single tape for every operation. Only their C+T
   page prints an options table, so there is nothing else to read; if a chain or
   motorised 25 mm blind ever turns out to differ, this is the place to fix it.
*/
window.NARU_LAD = (function () {
  var U = window.NWC_UI;

  /* code number -> [de, en, ro]. Descriptive, mine, not the supplier's. */
  var NAME = {
    '01': ['Wei\u00df', 'White', 'Alb'],
    '04': ['Cognac', 'Cognac', 'Coniac'],
    '08': ['Schwarzbraun', 'Black-brown', 'Maro-negru'],
    '24': ['Hellgrau', 'Light grey', 'Gri deschis'],
    '27': ['Schwarz', 'Black', 'Negru'],
    '42': ['Taupe', 'Taupe', 'Taupe']
  };

  var KIND = {
    LT: { on: 'tape', de: 'Leiterband', en: 'Tape ladder', ro: 'Band\u0103 textil\u0103' },
    LW: { on: 'tape', de: 'Leiterband 38 mm', en: '38 mm tape ladder', ro: 'Band\u0103 textil\u0103 38 mm' },
    LS: { on: 'cord', de: 'Schnurleiter', en: 'Cord ladder', ro: 'Sc\u0103ri\u021b\u0103 din \u0219nur' }
  };

  /* LT 29 and LT 30 sample to the SAME navy. On the capture they look alike
     too. Either they differ in something the screenshot cannot show, or one of
     the two readings is wrong - worth checking against the colour card before
     anyone reads meaning into two identical chips sitting side by side. */
  var LT = '01 F3F3F3,02 C4A273,03 A86F4E,04 AE7A58,05 814531,06 5D302A,' +
    '07 9E8063,08 645344,09 3E3E3A,10 C3C2BD,12 CEBAA3,14 2B2E2F,' +
    '15 AD8258,16 908074,17 887F71,18 D3CCBE,21 9D9483,22 F3F2E9,' +
    '24 BABABA,26 44454C,27 242424,28 827B70,29 29374F,30 29374F,' +
    '31 9A684D,32 3F6689,42 D2C8B4,44 899090,91 8D9985';

  var LW = '01 F2F2F2,07 9E7F63,08 645244,09 3D3E39,10 D3D2CB,15 AD8258,' +
    '26 44454C,27 242424,44 899090';

  /* Read off thin braided cords on a white card rather than solid squares, so
     these are the least precise of the three. The shades still line up with
     their LT twins, which is the check that they were read correctly at all. */
  var LS = '01 E9E9E9,08 51453E,12 CEB48C,18 D7CEBC,27 1C1E21,44 5B625F';

  function swatch(hex, cord) {
    if (cord) {
      return '<svg viewBox="0 0 48 48" aria-hidden="true">' +
        '<rect x="6" y="20" width="36" height="9" rx="4.5" fill="' + hex +
        '" stroke="rgba(0,0,0,.22)" stroke-width=".8"/>' +
        '<path d="M12 20l5 9M20 20l5 9M28 20l5 9M36 20l4 7" stroke="rgba(0,0,0,.16)" ' +
        'stroke-width=".9" fill="none"/></svg>';
    }
    return '<svg viewBox="0 0 48 48" aria-hidden="true">' +
      '<rect x="5" y="5" width="38" height="38" rx="3" fill="' + hex +
      '" stroke="rgba(0,0,0,.2)" stroke-width=".8"/></svg>';
  }

  /* Builds the option entries in the shape the configurator already renders:
     k, hex, an icon id, the three name fields lnName() reads, and the three
     label pairs T() reads. The icons are registered straight into NWC_UI.ICON,
     so opts() and ill() need no change at all. */
  function build(prefix, spec) {
    var kind = KIND[prefix], cord = kind.on === 'cord';
    return spec.split(',').map(function (pair) {
      var num = pair.slice(0, 2), hex = '#' + pair.slice(3);
      var code = prefix + ' ' + num, id = 'lad_' + prefix + num;
      var nm = NAME[num] || null;
      if (U && U.ICON) { U.ICON[id] = swatch(hex, cord); }
      return {
        k: code, hex: hex, ic: id,
        nde: nm ? code + ' \u00b7 ' + nm[0] : code,
        nen: nm ? code + ' \u00b7 ' + nm[1] : code,
        nro: nm ? code + ' \u00b7 ' + nm[2] : code,
        de: [code, nm ? nm[0] : kind.de],
        en: [code, nm ? nm[1] : kind.en],
        ro: [code, nm ? nm[2] : kind.ro]
      };
    });
  }

  var SETS = {
    'wood-50':   { on: KIND.LT.on, items: build('LT', LT) },
    'wood-70':   { on: KIND.LW.on, items: build('LW', LW) },
    'bamboo-65': { on: KIND.LS.on, items: build('LS', LS) }
  };

  /* Anything not listed returns null, and the configurator keeps its old six
     LN colours on the tape - unchanged behaviour rather than a guess. */
  function forProduct(mat, sw) {
    return SETS[mat + '-' + sw] || null;
  }

  /* width in mm -> surcharge as a fraction, per product and per operation.
     'ct' covers cord lock + tilter, 'chain' the mono chain, 'mot' motorised.
     An operation with no entry of its own falls back to ct; an EMPTY array
     means the product genuinely has no tape ladder there and must not get one. */
  var TAPES = {
    'wood-25':   { ct: [[12, 0.07]] },
    'bamboo-25': { ct: [[12, 0.07]] },
    'wood-50':   { ct: [[25, 0], [10, 0.05], [38, 0.05]],
                   chain: [[25, 0], [10, 0.05]],
                   mot: [[25, 0], [38, 0.05]] },
    'bamboo-50': { ct: [[25, 0], [10, 0.05], [38, 0.05]],
                   chain: [[25, 0]],
                   mot: [[25, 0], [38, 0.05]] },
    'wood-70':   { ct: [[38, 0.05]] },
    'bamboo-65': { ct: [[38, 0.05]], mot: [] }
  };

  function pctText(pct, lang) {
    if (!pct) {
      return lang === 'de' ? 'ohne Aufpreis' :
        (lang === 'ro' ? 'f\u0103r\u0103 cost suplimentar' : 'no extra charge');
    }
    return '+' + Math.round(pct * 100) + ' %';
  }

  /* Every tape width borrows the drawing already used for the old single tape
     card, but under a key of its own, so a photograph can later be uploaded per
     width without touching any code. */
  function tapeIcon(mm) {
    var id = 'tape_' + mm;
    if (U && U.ICON && !U.ICON[id]) {
      var src = (U.LAD && U.LAD[1]) ? U.ICON[U.LAD[1].ic] : null;
      if (src) { U.ICON[id] = src; }
    }
    return id;
  }

  /* Returns option entries the configurator can hand straight to opts(). The
     free width comes first, because it is the standard one. */
  function tapesFor(mat, sw, op) {
    var p = TAPES[mat + '-' + sw];
    if (!p) { return []; }
    var rows = p[op] || p.ct || [];
    return rows.map(function (r) {
      var mm = r[0], pct = r[1], w = mm + ' mm';
      return {
        k: 'tape' + mm, pct: pct, mm: mm, ic: tapeIcon(mm),
        de: ['Leiterband ' + w, pctText(pct, 'de')],
        en: [w + ' tape ladder', pctText(pct, 'en')],
        ro: ['Band\u0103 textil\u0103 ' + w, pctText(pct, 'ro')]
      };
    });
  }

  return { forProduct: forProduct, tapesFor: tapesFor, SETS: SETS, TAPES: TAPES, NAME: NAME };
})();
